import http from "./httpService";
import { apiUrl } from "../../config.js";

const apiEndpoint = apiUrl + "/dashboard/";

export function getDashboardAuth() {
  return http.get(apiEndpoint + "dashboard-auth");
}
